import { heroStat, heroTags } from '../data';

export default function Hero() {
  return (
    <section id="today" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-background-50 to-background-50" />
      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 py-10 md:py-16 lg:grid-cols-[1.6fr_1fr]">
        {/* 今日核心事件 */}
        <div className="flex flex-col rounded-xl border border-background-200 bg-background-50/80 p-5 md:p-8">
          <div className="flex flex-wrap items-center gap-2 md:gap-3">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-semibold text-primary-800">
              <i className="ri-fire-fill w-3.5 h-3.5 flex items-center justify-center" />
              今日核心事件
            </span>
            <span className="text-xs text-foreground-500">编号 #247 · 09.06 持续更新</span>
          </div>

          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
            「门店事件」对质前夜：
            <span className="text-primary-700">关键一夜完整还原</span>
          </h2>

          <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            我们把散落在 6 个渠道的 47 屏聊天记录、2 段录音与后台流水拼回了同一条线。
            编号一一对应每一屏记录，改口处单独标注——想深扒，顺着时间线和关键证据往下看就行。
          </p>

          <div className="mt-5 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-700"
              >
                <i className="ri-check-double-line w-3.5 h-3.5 flex items-center justify-center text-secondary-600" />
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              看完整时间线
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="#archive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-folder-2-line w-4 h-4 flex items-center justify-center" />
              拉取全部截图
            </a>
          </div>
        </div>

        {/* 今日数据速览 */}
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-3 gap-3">
            {heroStat.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-100 p-3 md:p-4">
                <p className="font-heading text-lg md:text-2xl font-bold text-foreground-950">{s.value}</p>
                <p className="mt-1 text-[11px] md:text-xs leading-tight text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-1 flex-col rounded-xl bg-secondary-600 p-4 md:p-5 text-background-50">
            <span className="inline-flex items-center gap-2 font-label text-xs font-semibold tracking-wide">
              <i className="ri-stackshare-line w-4 h-4 flex items-center justify-center" />
              今日入库速览
            </span>
            <ul className="mt-3 flex flex-col gap-2.5">
              <li className="flex items-center justify-between text-xs md:text-sm">
                <span>聊天记录</span>
                <span className="font-semibold">+31 屏</span>
              </li>
              <li className="flex items-center justify-between text-xs md:text-sm">
                <span>截图留痕</span>
                <span className="font-semibold">+17 张</span>
              </li>
              <li className="flex items-center justify-between text-xs md:text-sm">
                <span>线索旁证</span>
                <span className="font-semibold">+6 条</span>
              </li>
            </ul>
            <div className="mt-auto pt-4">
              <a href="#feed" className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-200 hover:text-accent-100">
                查看素材流
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}